<template>
    <div>
      <h1>Reset Password</h1>
      <ResetPasswordForm />
    </div>
  </template>
  
  <script>
  import ResetPasswordForm from '../components/ResetPasswordForm.vue';
  
  export default {
    components: {
      ResetPasswordForm
    }
  }
  </script>
  